import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { findDOMNode } from 'react-dom';
import { mergeStyles } from 'wix-rich-content-common';
import { MediaItemErrorMsg, Loader } from 'wix-rich-content-ui-components';
import VideoViewer from './video-viewer.js';
import { s as styles } from './default-video-styles-19c0e297.js';
import { VIDEO_TYPE_LEGACY, VIDEO_TYPE } from './types.js';
import { omit } from 'lodash';
import { isiOS } from 'wix-rich-content-editor-common';
import './reactPlayerWrapper.js';
import 'react-player';
import './constants.js';
import 'ricos-schema';
import 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import './get-video-source.js';
import './IframePlayer.js';
import './video-viewer-5226a68a.js';
import './style-inject.es-746bb8ed.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: "CENTER",
    width: {
      size: "CONTENT"
    },
    textWrap: true
  }
});
class VideoComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleReady", (player) => {
      if (!this.state.isLoaded && !this.props.componentData.tempData) {
        this.setState({ isLoaded: true });
      }
      this.handleDuration(player);
    });
    __publicField(this, "handleDuration", (player) => {
      setTimeout(() => {
        const duration = player.getDuration();
        if (duration) {
          this.saveDurationToData(duration);
        } else {
          this.setState({ shouldRenderDurationFix: true });
        }
      }, 3e3);
    });
    __publicField(this, "renderOverlay", (styles2) => {
      return /* @__PURE__ */ React.createElement("div", { className: classNames(styles2.video_overlay) });
    });
    __publicField(this, "renderLoader", () => {
      const {
        isLoading,
        componentData: { tempData, isCustomVideo }
      } = this.props;
      const loading = isLoading || tempData;
      return /* @__PURE__ */ React.createElement("div", { className: this.styles.videoOverlay }, /* @__PURE__ */ React.createElement(
        Loader,
        {
          type: "medium",
          isVerySlowFakeLoader: isCustomVideo,
          percent: this.props.loadingPercentage,
          disableProgress: !loading && !this.state.isLoaded
        }
      ));
    });
    __publicField(this, "onReloadIosFix", () => {
      if (isiOS()) {
        this.setState({ iosFixKey: this.state.iosFixKey + 1 });
      }
    });
    __publicField(this, "onReload", () => {
      this.setState({ isLoaded: false });
      this.onReloadIosFix();
    });
    __publicField(this, "saveDurationToData", (duration) => {
      const { componentData } = this.props;
      this.props.store.update(
        "componentData",
        __spreadProps(__spreadValues({}, omit(componentData, ["tempData"])), { duration }),
        this.props.block.getKey()
      );
    });
    __publicField(this, "renderPlayer", () => {
      const { theme, componentData, disabled, settings, setComponentUrl } = this.props;
      return /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          settings,
          onReady: this.handleReady,
          disabled,
          theme,
          setComponentUrl,
          onReload: this.onReload,
          isLoaded: this.state.isLoaded,
          key: this.state.iosFixKey
        }
      );
    });
    __publicField(this, "renderPlayerDurationFix", () => {
      const { theme, componentData, settings } = this.props;
      const stylesHide = {
        width: 0,
        height: 0,
        position: "absolute",
        overflow: "hidden",
        visibility: "hidden"
      };
      let timeoutId;
      const onReady = (player) => {
        const internalPlayer = player.getInternalPlayer();
        if (internalPlayer.play) {
          internalPlayer.play();
        } else {
          timeoutId = setTimeout(() => {
            var _a;
            (_a = player.getInternalPlayer()) == null ? void 0 : _a.play();
          }, 1e4);
        }
      };
      return /* @__PURE__ */ React.createElement("div", { style: stylesHide }, /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          theme,
          settings,
          onReady,
          onDuration: (duration) => {
            this.setState({ shouldRenderDurationFix: false });
            this.saveDurationToData(duration);
            clearTimeout(timeoutId);
          },
          muted: true
        }
      ));
    });
    __publicField(this, "onKeyDown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        this.props.onClick();
      }
    });
    const isPlayable = !props.blockProps;
    this.state = {
      isLoaded: false,
      isPlayable,
      iosFixKey: 1
    };
  }
  componentDidMount() {
    this.handlePlayerFocus();
  }
  componentDidUpdate() {
    this.handlePlayerFocus();
  }
  handlePlayerFocus() {
    const element = findDOMNode(this).querySelector("iframe, video");
    if (element) {
      element.tabIndex = -1;
    }
  }
  render() {
    this.styles = this.styles || mergeStyles({ styles, theme: this.props.theme });
    const {
      className,
      onClick,
      t,
      componentData: { error, tempData },
      isDraggable = true,
      isLoading
    } = this.props;
    const { isPlayable, isLoaded, shouldRenderDurationFix } = this.state;
    const containerClassNames = classNames(this.styles.video_container, className || "");
    const loading = isLoading || tempData || !isLoaded;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-hook": "videoPlayer",
        onClick,
        className: containerClassNames,
        onKeyDown: this.onKeyDown,
        draggable: isDraggable
      },
      !isPlayable && this.renderOverlay(this.styles, this.props.t),
      this.renderPlayer(),
      shouldRenderDurationFix ? this.renderPlayerDurationFix() : null,
      loading && !error && this.renderLoader(),
      error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t })
    );
  }
}
__publicField(VideoComponent, "type", { VIDEO_TYPE_LEGACY, VIDEO_TYPE });
VideoComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  blockProps: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  setComponentUrl: PropTypes.func,
  store: PropTypes.object.isRequired,
  block: PropTypes.object.isRequired,
  isDraggable: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadingPercentage: PropTypes.number
};

export { VideoComponent as Component, DEFAULTS, RICOS_DEFAULTS };
//# sourceMappingURL=video-component.js.map
